/**
 * @author Gananath Athukorala
 * @version 1.0
 * @since 25/10/2023
 */

import React, { useEffect, useMemo, useState } from "react"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import api from "../../services/ResApi"
import { Check, Close } from "@mui/icons-material"
import Alerts from "../../errorHandeling/Alerts"
import { FetchErrorHandeling } from "../../errorHandeling/FetchErrorHandeling"

const DeploymentSettings = () => {
  // data and fetching state
  const [appData, setAppData] = useState([])
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [appRowCount, setAppRowCount] = useState(0)

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  //table state
  const [columnFilters, setColumnFilters] = useState([])
  const [globalFilter, setGlobalFilter] = useState("")
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  // Advanced Settings
  let getAppConfig = {
    headers: { "User-Agent": "insomnia/2023.5.8" },
  }

  useEffect(() => {
    const approveTable = () => {
      setIsLoading(true)
      api
        .get("/sys/configs", getAppConfig)
        .then((res) => {
          setAppData(res.data?.dataList)
          setAppRowCount(res.data?.total)
          setIsLoading(false)

          setErrorMessages([])
          setIserror(false)
        })
        .catch((error) => {
          setIsLoading(false)
          FetchErrorHandeling(
            error,
            setIserror,
            setErrorMessages,
            setIserrorShow
          )
        })
      setIsError(false)
    }
    approveTable()
  }, [])

  // Table Titles
  const Cell = ({ cell }) => {
    if (cell.getValue() === true) {
      return <Check color="success" />
    } else if (cell.getValue() === false) {
      return <Close color="error" />
    } else {
      return null
    }
  }
  const columns = useMemo(
    () => [
      {
        accessorKey: "sysConfigName",
        header: "Sys Config Name",
      },
      {
        accessorKey: "value",
        header: "Value",
      },
      {
        accessorKey: "active",
        header: "Active",
        Cell: Cell,
      },
    ],
    [appData]
  )

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <br />
      <MaterialReactTable
        enableColumnVirtualization
        columns={columns}
        data={appData ?? []}
        state={{
          columnFilters,
          globalFilter,
          pagination,
          isLoading,
        }}
        getRowId={(row) => row.phoneNumber}
        initialState={{ showColumnFilters: false }}
        muiToolbarAlertBannerProps={
          isError
            ? {
                color: "error",
                children: "Error loading data",
              }
            : undefined
        }
        onColumnFiltersChange={setColumnFilters}
        onGlobalFilterChange={setGlobalFilter}
        onPaginationChange={setPagination}
        rowCount={appRowCount}
        muiTablePaginationProps={{
          rowsPerPageOptions: [5],
        }}
        editingMode="modal"
        enableColumnOrdering
        enableGrouping
        enablePinning
        enablePagination={false}
      />
    </div>
  )
}

export default DeploymentSettings
